import { Box, Button, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import scrollToElement from "helpers/scroll-to-element"
import { hideScrollbar } from "styles/utils"

const Container = styled(Box).attrs((props) => ({
  bg: props.theme.colors.polar,
  mb: { _: 2, tablet: 7 },
  p: 2,
  ...props,
}))``

const Heading = styled(Typography).attrs(() => ({
  as: "h2",
  fontSize: 16,
  fontWeight: "bold",
  p: 1,
}))`
  white-space: nowrap;
`

const LinksContainer = styled(Flex)`
  align-items: center;
  overflow-x: auto;
  white-space: nowrap;
  ${hideScrollbar}
`

const UnderlineLink = styled(Typography).attrs((props) => ({
  as: Button,
  color: "black",
  display: "inline-block",
  fontSize: 15,
  fontWeight: 500,
  m: 2,
  underline: true,
  variant: "text",
  ...props,
}))`
  text-decoration: underline;
  :hover,
  :active {
    text-decoration: none;
  }
`

const LandingMenu = ({ element }) => (
  <Container {...element.style}>
    <Flex alignItems="baseline" justifyContent="center">
      <Heading>JUMP TO:</Heading>
      <LinksContainer>
        {element.items.map((item, index) => (
          <UnderlineLink
            key={`menu-item-${index}`}
            onClick={() => scrollToElement(item.url)}
            {...item.style}
          >
            {item.text}
          </UnderlineLink>
        ))}
      </LinksContainer>
    </Flex>
  </Container>
)

LandingMenu.propTypes = {
  element: PropTypes.object,
}

export default LandingMenu
